import React from "react";
import { useTranslation } from "react-i18next";
import FilterMultiSelect, { FilterOption } from "./FilterMultiSelect";

export type UserFilterOption = FilterOption;

type UserFilterMultiSelectProps = {
  label?: string;
  allLabel?: string;
  icon?: React.ReactNode;
  pill?: boolean;
  triggerClassName?: string;
  hideChevron?: boolean;
  value: string[];
  options: UserFilterOption[];
  onChange: (value: string[]) => void;
};

const UserFilterMultiSelect = ({ allLabel = "All", ...props }: UserFilterMultiSelectProps) => {
  const { t } = useTranslation();
  return (
    <FilterMultiSelect
      {...props}
      allLabel={allLabel}
      selectAllLabel="All"
      emptyLabel="Select people"
      searchPlaceholder={t("search_people")}
      multipleLabel={count => t("dashboard.people_selected", { count })}
    />
  );
};

export default UserFilterMultiSelect;
